import * as React from 'react'
import cn from 'classnames'
import {
  WbCheckboxControl,
  WbControlError,
  WbControlHint,
} from '@workbench/react/dist'
import classes from './Checkbox.module.scss'

interface CheckboxProps {
  id?: string
  label: string
  hint?: string
  error?: string
  disabled?: boolean
  value?: boolean
  inline?: boolean
}

export const Checkbox: React.FunctionComponent<
  CheckboxProps & JSX.IntrinsicElements['input']
> = ({
  id,
  label,
  hint,
  error,
  disabled,
  inline,
  className,
  value,
  ...inputProps
}) => {
  return (
    <WbCheckboxControl
      className={cn(classes.checkbox, { [classes.inline]: inline }, className)}
    >
      <label>
        <input
          type="checkbox"
          id={id}
          checked={value}
          value={value}
          {...inputProps}
          disabled={disabled}
        />
        {label}
      </label>

      {hint && <WbControlHint>{hint}</WbControlHint>}
      {error && <WbControlError>{error}</WbControlError>}
    </WbCheckboxControl>
  )
}
